// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"1ee08a33","297":"ee561cc1","643":"9726b0d8"}[chunkId] + ".chunk.js";
};